export function addToCartEvents() {
	if (!window.fluxWooAjax) {
		return;
	}

	const sentinel = document.querySelector("[data-cart-ajax-sentinel]");
	if (!sentinel || !("IntersectionObserver" in window)) {
		return;
	}

	const observer = new IntersectionObserver(([entry], obs) => {
		if (!entry || !entry.isIntersecting) {
			return;
		}

		obs.disconnect();

		import("./add-to-cart.js")
			.then(({ initAddToCart }) => initAddToCart())
			.catch((err) => {
				console.error("Failed to load module:", err);
			});
	});

	observer.observe(sentinel);
}
